export interface ReviewVideo {
  name: string
  comment: string
  url: string
  thumbnail: string
  reviewIndex: number
}

export const reviewVideos: ReviewVideo[] = [
  {
    name: '9주간 깨봉을 체험한 학부모들의 이야기',
    comment: '아이가 그림으로 미분을 얘기해요.',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_1.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_1.jpg',
    reviewIndex: 1,
  },
  {
    name: '3개월 동안 깨봉을 체험한 성민이의 이야기',
    comment: '눈 감고도 풀 수 있을 정도로 쉬워졌어요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_2.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_2.jpg',
    reviewIndex: 2,
  },
  {
    name: '깨봉을 경험한 아이들의 놀라운 변화',
    comment: '삼각함수 문제도 깨봉으로 맞혔어요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_8_1.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_8.png',
    reviewIndex: 8,
  },
  {
    name: '깨봉 1호 제자, 카이스트 교수의 후기',
    comment: '의미를 파악하면 안 풀리는 문제가 없어요.',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_15.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_15.png',
    reviewIndex: 15,
  },
  {
    name: '깨봉을 만나 다행이라는 학부모님의 이야기',
    comment: '수학 싫어하던 아이가 깨봉은 매일해요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_20.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_20.png',
    reviewIndex: 20,
  },
  {
    name: '세 자녀를 둔 학부모님의 이야기',
    comment: '저렇게 재밌게 가르쳐줄 수 있구나!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_19.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_19.png',
    reviewIndex: 19,
  },
  {
    name: '수학에 자신감을 얻은 재형이 이야기',
    comment: '수능 문제도 풀 수 있다니 신기해요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_17.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_17.png',
    reviewIndex: 17,
  },
  {
    name: '수학을 그림으로 표현하게 된 재승이 이야기',
    comment: '이제 수학하면 도형이 딱 떠올라요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_12.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_12.png',
    reviewIndex: 12,
  },
  {
    name: '수포자를 극복했다는 기훈이 이야기',
    comment: '깨봉이 3년은 더 쉽게 가르쳐줬어요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_13.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_13.png',
    reviewIndex: 13,
  },
  {
    name: '수학에 다시 흥미를 갖게 된 지훈이 이야기',
    comment: '깨봉수학은? 쉬.운.수.학!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_11.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_11.png',
    reviewIndex: 11,
  },
  {
    name: '깨봉을 직접 체험한 학생/학부모님의 후기',
    comment: '뜻을 알게 되니까 쉽게 풀 수 있어요!',
    url: 'https://quebon-public-media.s3.ap-northeast-2.amazonaws.com/expr_10.mp4/stream.m3u8',
    thumbnail: 'https://d2ql3aoebfyj3b.cloudfront.net/brand/expr_10.png',
    reviewIndex: 10,
  },
]
